import { CKEditor } from "@ckeditor/ckeditor5-react";
import "./ck-editor.css";
import { ClassicEditor, Essentials, Paragraph, Heading, Bold, Italic, Underline, Strikethrough, Subscript, Superscript, Code, Link, List, ListProperties, Indent, IndentBlock, Alignment, Font, Highlight, RemoveFormat, BlockQuote, Table, TableToolbar, MediaEmbed, Image, ImageToolbar, ImageCaption, ImageStyle, ImageUpload, Undo, Style, } from "ckeditor5";
import "ckeditor5/ckeditor5.css";

interface Props {
    value?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
}

export default function RichTextEditor({ value = "", disabled = false, onChange }: Props) {
    return (
        <div className="rich-text-editor-container">
            <CKEditor
                editor={ClassicEditor}
                data={value}
                disabled={disabled}
                config={{
                    licenseKey: "GPL",
                    plugins: [
                        Essentials,
                        Paragraph,
                        Heading,
                        Bold,
                        Italic,
                        Underline,
                        Strikethrough,
                        Subscript,
                        Superscript,
                        Code,
                        Link,
                        List,
                        ListProperties,
                        Indent,
                        IndentBlock,
                        Alignment,
                        Font,
                        Highlight,
                        Style,
                        RemoveFormat,
                        BlockQuote,
                        Table,
                        TableToolbar,
                        MediaEmbed,
                        Image,
                        ImageToolbar,
                        ImageCaption,
                        ImageStyle,
                        ImageUpload,
                        Undo,
                    ],
                    toolbar: {
                        items: [
                            "undo",
                            "redo",
                            "|",
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "underline",
                            "strikethrough",
                            "|",
                            "subscript",
                            "superscript",
                            "|",
                            "fontSize",
                            "fontFamily",
                            "fontColor",
                            "fontBackgroundColor",
                            "|",
                            "highlight",
                            "|",
                            "style",
                            "|",
                            "link",
                            "|",
                            "bulletedList",
                            "numberedList",
                            "|",
                            "outdent",
                            "indent",
                            "|",
                            "alignment",
                            "|",
                            "blockQuote",
                            "|",
                            "insertTable",
                            "|",
                            "mediaEmbed",
                            "|",
                            "removeFormat",
                        ],
                    },
                    list: {
                        properties: {
                            styles: true,
                            startIndex: true,
                            reversed: true,
                        },
                    },
                    style: {
                        definitions: [
                            { name: "Line spacing 1.0", element: "p", classes: ["line-spacing-1"] },
                            { name: "Line spacing 1.15", element: "p", classes: ["line-spacing-115"] },
                            { name: "Line spacing 1.5", element: "p", classes: ["line-spacing-15"] },
                            { name: "Line spacing 2.0", element: "p", classes: ["line-spacing-2"] },
                            { name: "Line spacing 2.5", element: "p", classes: ["line-spacing-25"] },
                            { name: "Line spacing 3.0", element: "p", classes: ["line-spacing-3"] },
                            { name: "Paragraph spacing: None", element: "p", classes: ["paragraph-spacing-0"] },
                            { name: "Paragraph spacing: 6px", element: "p", classes: ["paragraph-spacing-6"] },
                            { name: "Paragraph spacing: 12px", element: "p", classes: ["paragraph-spacing-12"] },
                            { name: "Paragraph spacing: 18px", element: "p", classes: ["paragraph-spacing-18"] },
                            { name: "Paragraph spacing: 24px", element: "p", classes: ["paragraph-spacing-24"] },
                            { name: "Document paragraph", element: "p", classes: ["line-spacing-15", "paragraph-spacing-12"] },
                            { name: "Compact paragraph", element: "p", classes: ["line-spacing-1", "paragraph-spacing-6"] },
                            { name: "Wide paragraph", element: "p", classes: ["line-spacing-2", "paragraph-spacing-24"] },
                        ],
                    },
                    heading: {
                        options: [
                            { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
                            { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
                            { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                            { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
                            { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
                        ],
                    },
                    table: {
                        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
                    },
                }}
                onChange={(_, editor) => {
                    onChange?.(editor.getData());
                }}
            />
        </div>
    );
}